export default function OrganizeQuotes(quotes) {
    const newArr = []
    let FavNum = 0
    let RecNum = 0
    quotes.forEach(policy => {
        if(policy.favorite){
            newArr.unshift(policy)
            FavNum += 1
            return
        }
        if(policy.view_status == "Recomendada" || policy.view_status == 1){
            newArr.splice(RecNum+FavNum, 0, policy)
            RecNum+=1
            return
        }
        newArr.push(policy)
        return
    });
    return newArr
}